import React from 'react';
import { Modal, View, Text, Pressable } from 'react-native';
import CloseIcon from '@mui/icons-material/Close';
import theme from '../../theme';

export default function Dialog({ title, visible, onClose, children, footer }) {
  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={onClose}>
      <View style={{
        flex: 1,
        backgroundColor: theme.colors.surfaceOverlay,
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20,
      }}>
        <View style={{
          width: '100%',
          maxWidth: 480,
          backgroundColor: theme.colors.surfaceCard,
          borderRadius: theme.radii.lg,
          padding: 24,
        }}>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
            <Text style={{
              fontFamily: theme.typography.fontDisplay,
              fontSize: theme.typography.size.lg,
              color: theme.colors.textPrimary,
            }}>
              {title}
            </Text>
            <Pressable onPress={onClose} hitSlop={8}>
              <CloseIcon style={{ width: 20, height: 20, color: theme.colors.textTertiary }} />
            </Pressable>
          </View>

          {children}

          {footer ? <View style={{ marginTop: 24 }}>{footer}</View> : null}
        </View>
      </View>
    </Modal>
  );
}